import React from 'react';
import ReactDOM from 'react-dom';

// this is the view class

export default class Map extends React.Component {

    componentDidMount () {
        // we initialize the map
        this.props.init_map(ReactDOM.findDOMNode(this).parentNode);
    }

    render (){
        return <div />;
    }
};